import {setCookie, getCookie, swalSuccessWithButton, swalError, swalSuccessNoButton} from "./core";
import Swiper from 'swiper';

window.Swiper = Swiper;

class Template {
    // Constructor
    constructor(landingPage) {
        this.changeLanguage();
        this.changeHeader();
        this.headers();
        this.footers();
        this.forms();
        this.landingPage(landingPage);
        this.multipleMenu();
        this.dialog();
    }

    // Change language
    changeLanguage() {
        $('.change-language').click(function () {
            let locale = $(this).data('locale');
            setCookie('language-js', locale, 365);
        })
    }

    // Change header
    changeHeader() {
        $(document).on('click', '.change-header', function () {
            let route = $(this).data('route');
            if (!route || !String(route).trim()) {
                return;
            }
            $.ajax({
                url: route,
                type: 'post',
                dataType: 'json',
                data: {

                }
            }).done(function (json) {
                setTimeout(() => {
                    swalSuccessNoButton(json);
                    window.location.href = json.data.route;
                }, 1500);

            }).fail(function (json) {
                swalError(json);
            });
        });
    }

    // Dialog
    dialog(){
        if(getCookie("cookieWarning")) {
            $('.dialog-02.DialogWarningContainer').addClass('d-none')
        } else {
            $('.dialog-02.DialogWarningContainer').removeClass('d-none')
        }
        $(document).on('click', '.dw-dialog-02.DialogWarningContainer .btn-action', function () {
            $('.dialog-02.DialogWarningContainer').addClass('d-none')
            setCookie('cookieWarning', true, 365)
        });
    }

    // Footers
    footers() {
        // Footer 1
        $(document).on('click', '.ButtonsActions .Button', function () {
            $(this).closest('footer').toggleClass('Showed')
        })

        // Footer 2
        $(document).on('click', '.mxg-footer-2 .toggle-footer-menu', function () {
            $('.mxg-footer-2 .footer-top-container, .mxg-footer-2 .footer-bottom .payment-methods-container').slideToggle()
        })
    }

    // Forms
    forms() {
        // Login and register 4
        new Swiper('.dw-register-04 .swiper-container', {
            direction: 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            mousewheel: true,
        });
    }

    // Headers
    headers() {
        // Header fixed
        $(document).on('click', '.btn-opened-menu', function () {
            let obj = $('.mxg-header-fixed');
            obj.fadeIn();

            setTimeout(function () {
                obj.addClass('opened')
            }, 250)
        });

        $(document).on('click', '.btn-closed-menu, .mxg-header-fixed .mxg-header-fixed-bg', function () {
            let obj = $('.mxg-header-fixed');
            obj.hide();
            obj.removeClass('opened')
        });


        // Header 2
        $(document).on('click', '.showSidebarRoutes', function () {
            if($('.html-header-2').hasClass('showingHeader')) {
                $('.html-header-2').removeClass('showingHeader')

                setTimeout(() => {
                    $('.html-header-2').removeClass('hidden')
                }, 300);
            } else {
                $('.html-header-2').addClass('showingHeader')
                $('.html-header-2').addClass('hidden')
            }
        });
        // Header 2

        // Header 3
        if ($(window).scrollTop() >= 200) {
            $('.mxg-header-3 .mxg-desktop').addClass('sticky-menu');
        }

        $(window).scroll(function(){
            if ($(window).scrollTop() >= 200) {
                $('.mxg-header-3 .mxg-desktop').addClass('sticky-menu');
            }
            else {
                $('.mxg-header-3 .mxg-desktop').removeClass('sticky-menu');
            }
        });
        // Header 3

        // header 4
        $(document).on('click', '.mxg-header-4 .navbar-toggler', function () {
            $('body').toggleClass('hidden')
            $(this).closest('.mxg-header-4').toggleClass('show-menu')
            $('.mini-modal').removeClass('active')

            $('.mxg-header-4 .menu-mobile-container').fadeToggle('fast')
        })

        $(document).on('click', '.mxg-header-4 .close-menu-mobile', function () {
            $('.mxg-header-4').toggleClass('show-menu')
            
            $('.mxg-header-4 .menu-mobile-container').fadeToggle('fast')
        })

        $(document).on('click', '.mxg-header-4 .menu-mobile-container .mini-modal-toggle', function () {
            let target = $(this).data('target')
            $(`#${target}`).toggleClass('active')
        })

        $(document).on('click', '.mxg-header-4 .menu-mobile-container .button-close', function () {
            $('.mini-modal').removeClass('active')
        })
        // header 4
    }

    // Landing page
    landingPage(landingPage) {
        if (landingPage != null) {
            let firstVisit = localStorage.getItem('first_visit');

            if (firstVisit === null) {
                localStorage.setItem('first_visit', landingPage);
                window.location.href = landingPage;
            }
        }
    }

    // Mobile shortcut
    mobileShortcut() {
        let deferredPrompt;

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/service-worker.js')
                .then((registration) => {
                    console.log('Service worker registration succeeded:', registration);
                }, /*catch*/ (error) => {
                    console.error(`Service worker registration failed: ${error}`);
                });
        } else {
            console.error('Service workers are not supported.');
        }

        if (!localStorage.getItem('mobile-shortcut') || localStorage.getItem('mobile-shortcut') !== 'inactive') {
            $('#dialogItem').addClass('Opened');
        }

        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            deferredPrompt = event;
        });

        $('#install-shortcut').click(function () {
            $('#dialogItem').removeClass('Opened');
            deferredPrompt.prompt();

            deferredPrompt.userChoice
                .then(() => {
                    deferredPrompt = null;
                });
        });

        $('#close-shortcut').click(function () {
            localStorage.setItem('mobile-shortcut', 'inactive');
            $('#dialogItem').removeClass('Opened');
            deferredPrompt = null;
        });
    }

    // Multiple menu
    multipleMenu(){
        $(document).on('click', '.dw-sidebar-sections-01 .show-hide-sidebar-sections, .dw-sidebar-sections-01 .close-sidebar-sections, .dw-sidebar-sections-01 .hide-sidebar', function () {
            $('.sidebar-sections').toggle('fast')
        })

        $(document).on('click', '.dw-sidebar-sections-01 .setPartials', function () {
            $(this).closest('.sections-items').find('.setPartials').removeClass('active')

            $(this).addClass('active')
        })

        $(document).on('click', '.dw-sidebar-sections-01 .setModule', function () {
            $(this).toggleClass('active')

            let module = $(this).data('item')
            $(`.dw-home-module-important.dw-home-module-${module}`).toggle()
        })

        $(document).on('click', '.dw-sidebar-sections-01 .cancelButton', function () {
            $('.dw-sidebar-sections-01 .sidebar-sections .sections-items li.setModule.active').click()
        })
    }

    // Promo modal
    promoModal(scroll, oneTime, url, image) {
        let $body = $('body');
        let $window = $(window);
        let $bodyHeight = $body.innerHeight();
        let $windowHeight = $window.innerHeight();
        localStorage.removeItem(`promo-modal-one-time-${url}`);

        if (scroll === '1') {
            if ($bodyHeight > $windowHeight) {
                $window.scroll(function () {
                    if ($window.scrollTop() > (parseInt($bodyHeight) / 2) - (parseInt($windowHeight) / 2)) {
                        Template.showPromoModal($body, oneTime, url, image);
                    }
                });
            } else {
                Template.showPromoModal($body, oneTime, url, image);
            }
        } else {
            Template.showPromoModal($body, oneTime, url, image);
        }
        console.log('body', $body);
    }

    // Show promo modal
    static showPromoModal($body, oneTime, url, image) {
        if (oneTime === '1') {
            if (localStorage.getItem(`promo-modal-image-${url}`) !== image) {
                localStorage.setItem(`promo-modal-image-${url}`, image);
                $body.css({'overflow': 'hidden'});
                $('.welcome-scroll').fadeIn();

                $(document).on('click', '.welcome-scroll .welcome-close, .welcome-scroll .welcome-scroll-bg', function () {
                    $body.css({'overflow': ''});
                    $('.welcome-scroll').fadeOut();
                })
            }
        } else {
            if (localStorage.getItem(`promo-modal-one-time-${url}`) !== 'success') {
                localStorage.setItem(`promo-modal-one-time-${url}`, 'success');
                $body.css({'overflow': 'hidden'});
                $('.welcome-scroll').fadeIn();

                $(document).on('click', '.welcome-scroll .welcome-close, .welcome-scroll .welcome-scroll-bg', function () {
                    $body.css({'overflow': ''});
                    $('.welcome-scroll').fadeOut();
                })
            }
        }
    }
}

window.Template = Template;